import { makeAutoObservable } from 'mobx';

export class RestartSettingsData {
  maxRestartAttempts = 0;
  isMaxRestartAttempts = false;
  maxLoss = 0;
  isMaxLoss = true;
  maxMinutesInTradePlan = 0;
  isMaxMinutesInTradePlan = false;
  numberOfTrades = 0;
  isNumberOfTrades = false;
  deactivateOnRestart = true;

  constructor(initialData) {
    makeAutoObservable(this);
    if (initialData) {
      Object.keys(initialData).forEach(
        (field) => (this[field] = initialData[field])
      );
    }
  }

  setMaxRestartAttempts = (number) => {
    this.maxRestartAttempts = number;
  }
  setIsMaxRestartAttempts = (bool) => {
    this.isMaxRestartAttempts = bool;
  }
  setMaxLoss = (number) => {
    this.maxLoss = number;
  }
  setIsMaxLoss = (bool) => {
    this.isMaxLoss = bool;
  }
  setMaxMinutesInTradePlan = (number) => {
    this.maxMinutesInTradePlan = number;
  }
  setIsMaxMinutesInTradePlan = (bool) => {
    this.isMaxMinutesInTradePlan = bool;
  }
  setNumberOfTrades = (number) => {
    this.setNumberOfTrades = number;
  }
  setIsNumberOfTrades = (bool) => {
    this.isNumberOfTrades = bool;
  }
  setDeactivateOnRestart = (bool) => {
    this.deactivateOnRestart = bool;
  }
  resetToDefaults = () => {
    this.maxRestartAttempts = 0;
    this.isMaxRestartAttempts = false;
    this.maxLoss = 0;
    this.isMaxLoss = true;
    this.maxMinutesInTradePlan = 0;
    this.isMaxMinutesInTradePlan = false;
    this.numberOfTrades = 0;
    this.isNumberOfTrades = false;
    this.deactivateOnRestart = true;
  }
  returnJson = () => {
    return {
      maxRestartAttempts: this.maxRestartAttempts,
      isMaxRestartAttempts: this.isMaxRestartAttempts,
      maxLoss: this.maxLoss,
      isMaxLoss: this.isMaxLoss,
      maxMinutesInTradePlan: this.maxMinutesInTradePlan,
      isMaxMinutesInTradePlan: this.isMaxMinutesInTradePlan,
      numberOfTrades: this.numberOfTrades,
      isNumberOfTrades: this.isNumberOfTrades,
      deactivateOnRestart: this.deactivateOnRestart,
    };
  }
}
